/* eslint-disable import/prefer-default-export,global-require,no-console */
import { initializeApp } from 'firebase/app'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { log } from '../utils'
import env from '../env'

const getFirebaseConfig = () => {
  let config
  try {
    // eslint-disable-next-line import/no-unresolved
    config = (env.REACT_APP_ENVIRONMENT === 'prod') ? require('../constants/firebase-production.json') : require('../constants/firebase-stage.json')
  } catch (ex) {
    // console.log('unable to find firebase config')
  }
  return config
}

const firebaseConfig = getFirebaseConfig()

const app = firebaseConfig ? initializeApp(firebaseConfig, 'hogwarts') : undefined
const firebaseAnalytics = firebaseConfig ? getAnalytics(app) : undefined

const getRealFirebaseObj = () => ({
  analytics: () => ({
    logScreenView: (params) => {
      log(`Web ScreenView: ${JSON.stringify(params)}`)
      logEvent(firebaseAnalytics, 'screen_view', params)
    },
    logEvent: (trackId, params) => {
//      log(`calling logEvent: ${trackId}`)
      logEvent(firebaseAnalytics, trackId, params)
    },
  }),
})

const firebase = firebaseConfig
    ? getRealFirebaseObj() : {
      analytics: () => ({
        logScreenView: (params) => {
          if (!params || !params.screen_name) {
            console.error('logScreenView called without screen  name')
          }
          if (!params || !params.screen_class) {
            console.error('logScreenView called without screen class name')
          }
        },
        logEvent: (trackId, params) => {
          if (trackId.length > 40) {
            console.error('ID too long for analytics: ', trackId)
          }
          if (!params || !params.screen_name) {
            console.error(`logEvent called without screen name, trackId: ${trackId}, params: ${params != null ? JSON.stringify(params) : 'null'}`)
          }
          if (!params || params.screen_name === 'notAvailable') {
            console.error(`logEvent called with "notAvailable" screen name, trackId: ${trackId}, params: ${params != null ? JSON.stringify(params) : 'null'}`)
          }
          // console.log('event: ', trackId)
        },
      }),
    }

export { firebase }
